'use strict';

/*
  This is a helper which ensures that if multiple request to the same endpoint are made,
  only the last one is able to call the callback.

  Example promblem schenario:
    1. request #1 takes a decent amount of time to respond,
    2. request #2 takes a very short time to respond.
    3. request 2 comes back and calls the setter,
    4. request 1 comes back and calls the setter but now the UI has the wrong data returned by request 1
       and not request 2.
*/
var safeFetch = function (fetchCallback, setCallback) {
    var active = true;
    fetchCallback().then(function (results) {
        if (active)
            setCallback(results);
    });
    return function () {
        active = false;
    };
};

module.exports = safeFetch;
